export const OPS_STATUS_OPTIONS = [
  "Pending",
  "Under review",
  "Converted",
  "valid response",
  "Improve - KB - RD",
];

export function getOpsStatusBadgeClass(status) {
  switch (status) {
    case "Converted":
      return "bg-emerald-50 text-emerald-700 border-emerald-300";
    case "valid response":
      return "bg-teal-50 text-teal-700 border-teal-300";
    case "Under review":
      return "bg-sky-50 text-sky-700 border-sky-300";
    case "Improve - KB - RD":
      return "bg-amber-50 text-amber-700 border-amber-300";
    case "Pending":
    default:
      return "bg-yellow-50 text-yellow-700 border-yellow-300";
  }
}

export function getOpsStatusDotColor(status) {
  switch (status) {
    case "Converted":
      return "bg-emerald-500";
    case "valid response":
      return "bg-teal-500";
    case "Under review":
      return "bg-sky-500";
    case "Improve - KB - RD":
      return "bg-amber-500";
    case "Pending":
    default:
      return "bg-yellow-500";
  }
}
